import { render, staticRenderFns } from "./BidPlacedMessage.vue?vue&type=template&id=c5e9c3cc&scoped=true"
import script from "./BidPlacedMessage.vue?vue&type=script&lang=js"
export * from "./BidPlacedMessage.vue?vue&type=script&lang=js"
import style0 from "./BidPlacedMessage.vue?vue&type=style&index=0&id=c5e9c3cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e9c3cc",
  null
  
)

export default component.exports